// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"59427a92","239":"594ea88a"}[chunkId] + ".chunk.js";
};